import * as React from 'react';
import { RouteComponentProps, navigate } from '@reach/router';
import { useDispatch, useSelector } from "react-redux";
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

import { actions } from '../services/auth';

import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import AuthButton from '../components/AuthButton';
import { RootState } from '../store';
import { useEffect } from 'react';


const DashboardPage: React.FC<RouteComponentProps> = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.auth);

  const onGoogleLogin = () => {
    dispatch(actions.signIn('google.com'));
  }
  const onFacebookLogin = () => {
    dispatch(actions.signIn('facebook.com'));
  }

  useEffect(() => {
    if (state.user) {
      navigate('/');
    }
  }, [ state.user ]);

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>

        <AuthButton type="google.com" onClick={onGoogleLogin} loading={state.signInLoading === 'google.com'} />
        <AuthButton type="facebook.com" onClick={onFacebookLogin} loading={state.signInLoading === 'facebook.com'} />

      </Box>
    </Container >
  );
}

export default DashboardPage;